import { createContext } from "react";

export const FormContext = createContext<{ basePath: string }>({
  basePath: "",
});
